import constant from 'Constants';
import listService from 'ListService';
class MobileFormsConstants {

    get ICON_CAROT_DOWN() { return "fa pf-carot-down"; }
    get ICON_CAROT_LEFT() { return "fa pf-carot-left"; }
    get NEW_SECTION() { return "New section"; }
    get LIST_FONTS() { return Object.freeze([8, 9, 10, 11, 12, 14, 16, 18, 20, 24, 28, 32, 48]); }
    get LIST_MARGINS() { return Object.freeze([10, 11, 12, 14, 16, 18, 20, 24, 28, 32, 48]); }
    get MARGIN_ATTRIBUTE_NAME() {return '~margins'; }
    get TOP_MARGIN() { return ['top']; }
    get BOTTOM_MARGIN() { return ['bottom']; }
    get TOP_BOTTOM_MARGIN() { return ['top', 'bottom']; }
    get NONE_MARGIN() { return ['none']; }

    get FONT_DEFAULT_8() { return 8; }
    get FONT_DEFAULT_10() { return 10; }
    get FONT_DEFAULT_14() { return 14; }
    get FONT_DEFAULT_18() { return 18; }
    get FONT_DEFAULT_20() { return 20; }
    get MARGIN_DEFAULT_10() { return 8; }
    get MARGIN_EMPTY_VALUE() { return "5"; }
    get DEFAULT_MARGINS() { return {top: "5", right: "5", bottom: "10", left: "5"};   }
    get CONTROL_KEY() { return 16 }
    get SHIFT_KEY() { return 17 } 
    get DELETE_QUESTION() { return "Are you sure you would like to return all contained objects to the canvas and delete "; }
    get BLOCK() { return "block"; }
    get NONE() { return "none"; }
    get MOBILE_INITIAL_HEIGHT() { return "auto"; }
    get MOBILE_INITIAL_WIDTH() { return "80%"; }
    get SMALLER_SCREEN_PADDING() { return "20px"; } 
    get LINE_HEIGHT_FACTOR() { return 1.4; }
    get TEXT_INPUT_MIN_HEIGHT() { return 22; }
    get INPUT_PADDING_FACTOR() { return 4; }
    get DEFAULT_TABLE_HEIGHT() { return 240; }
    get DEFAULT_WEBSIGNATURE_HEIGHT() { return 140; }
    get DEFAULT_HEIGHT() { return 22; }
    get DEFAULT_MARGIN() { return 'bottom'; }
    get MULTILINE_MAX_LINES() { return 4; }
    get TIMES_WIZARD_WAS_OPENED() { return 2; }
    get ALERT_MESSAGE_HEADER() { return "Mobile Apps Wizard"; }
    
    get PREVIEW_DEFAULT_STAGE() { return "all"; }
    get PREVIEW_DEFAULT_ROLE() { return "all"; }
    get PREVIEW_DEFAULT_DEVICE() { return "phone"; }
    get PREVIEW_DEFAULT_ORIENTATION() { return "portrait"; }

    get SECION_HEIGHT_RISK(){ return 20; }
    get MIN_SECTION_HEIGHT(){ return 36; }
    get MIN_SECTION_FONTSIZE(){ return 18; }

    get MOBILE_ACCOUNT_VIEW() { return "MobileViews"; }
    get MOBILE_ACCOUNT_MESSAGE() { 
        return new Map([
            [
                "hasMobileDesign", {header: "Mobile Feature", 
                                    content: "Your account does not have the mobile feature enabled. Would you like to delete your mobile design? You will lose all your mobile changes, this cannot be undone.",
                                    ok: false
                                }
            
            ],
            [
                "noMobileDesign", {header: "Mobile Feature", 
                                   content: `Your account does not have the mobile feature enabled.<br/>Please contact the <a class="sales-link" href="mailto:${listService.salesEmailAddress}?subject=Inquiry for Mobile Feature&body=We're interested in adding the mobile feature to our app. Could you please provide any relevant details? Thanks!">sales team</a> for more information.`,
                                   ok: true
                                }
            
            ],
            [
                "desktopIsDirty", {header: "Save Desktop App", 
                                   content: "You must save your app to continue. Would you like to save the changes you made to this app?",
                                   ok: false
                                }
            
            ]
        ])
    }                                           

    get BADGES() {
        return new Map([
            [
                "normal", '<svg viewBox="0 0 576 512" class="pf-badge mobile-badge" xmlns="http://www.w3.org/2000/svg">\
                        <path fill="#ffffff" d="M173.898 439.404l-166.4-166.4c-9.997-9.997-9.997-26.206 0-36.204l36.203-36.204c9.997-9.998 26.207-9.998 36.204 0L192 312.69 432.095 72.596c9.997-9.997 26.207-9.997 36.204 0l36.203 36.204c9.997 9.997 9.997 26.206 0 36.204l-294.4 294.401c-9.998 9.997-26.207 9.997-36.204-.001z" class=""> \
                            <title> Normal </title> \
                        </path>\
                    </svg>'],
            [
                "disabled", '<svg viewBox="0 0 576 512" class="pf-badge mobile-badge" xmlns="http://www.w3.org/2000/svg">' +
                    '<path fill="#ffffff" d="M408.781 128.007C386.356 127.578 368 146.36 368 168.79V256h-8V79.79c0-22.43-18.356-41.212-40.781-40.783C297.488 39.423 280 57.169 280 79v177h-8V40.79C272 18.36 253.644-.422 231.219.007 209.488.423 192 18.169 192 40v216h-8V80.79c0-22.43-18.356-41.212-40.781-40.783C121.488 40.423 104 58.169 104 80v235.992l-31.648-43.519c-12.993-17.866-38.009-21.817-55.877-8.823-17.865 12.994-21.815 38.01-8.822 55.877l125.601 172.705A48 48 0 0 0 172.073 512h197.59c22.274 0 41.622-15.324 46.724-37.006l26.508-112.66a192.011 192.011 0 0 0 5.104-43.975V168c.001-21.831-17.487-39.577-39.218-39.993z" class=""> \
                                <title> Disabled </title> \
                            </path>\
                      </svg>'],
            [
                "hidden", '<svg viewBox="0 0 576 512" class="pf-badge mobile-badge" xmlns="http://www.w3.org/2000/svg">\
                        <path fill="#ffffff" d="M286.693 391.984l32.579 46.542A333.958 333.958 0 0 1 288 440C168.19 440 63.031 376.051 6.646 280.369a47.999 47.999 0 0 1 0-48.739c24.023-40.766 56.913-75.775 96.024-102.537l57.077 81.539C154.736 224.82 152 240.087 152 256c0 74.736 60.135 135.282 134.693 135.984zm282.661-111.615c-31.667 53.737-78.747 97.46-135.175 125.475l.011.015 41.47 59.2c7.6 10.86 4.96 25.82-5.9 33.42l-13.11 9.18c-10.86 7.6-25.82 4.96-33.42-5.9L100.34 46.94c-7.6-10.86-4.96-25.82 5.9-33.42l13.11-9.18c10.86-7.6 25.82-4.96 33.42 5.9l51.038 72.617C230.68 75.776 258.905 72 288 72c119.81 0 224.969 63.949 281.354 159.631a48.002 48.002 0 0 1 0 48.738zM424 256c0-75.174-60.838-136-136-136-17.939 0-35.056 3.473-50.729 9.772l19.299 27.058c25.869-8.171 55.044-6.163 80.4 7.41h-.03c-23.65 0-42.82 19.17-42.82 42.82 0 23.626 19.147 42.82 42.82 42.82 23.65 0 42.82-19.17 42.82-42.82v-.03c18.462 34.49 16.312 77.914-8.25 110.95v.01l19.314 27.061C411.496 321.2 424 290.074 424 256zM262.014 356.727l-77.53-110.757c-5.014 52.387 29.314 98.354 77.53 110.757z" class="">\
                            <title> Hidden </title> \
                        </path>\
                    </svg>'],
            [
                "readonly", '<svg viewBox="0 0 576 512" style="left:4px" class="pf-badge mobile-badge" xmlns="http://www.w3.org/2000/svg">\
                            <path fill="#ffffff" d="M400 224h-24v-72C376 68.2 307.8 0 224 0S72 68.2 72 152v72H48c-26.5 0-48 21.5-48 48v192c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V272c0-26.5-21.5-48-48-48zm-104 0H152v-72c0-39.7 32.3-72 72-72s72 32.3 72 72v72z" class="" >\
                            <title> Read-Only </title> \
                        </path>\
                      </svg>'],
            [
                "mandatory", '<svg viewBox="0 0 576 512" class="pf-badge mobile-badge mobile-badge-mandatory" xmlns="http://www.w3.org/2000/svg">\
                            <path fill="#ffffff" d="M176 432c0 44.112-35.888 80-80 80s-80-35.888-80-80 35.888-80 80-80 80 35.888 80 80zM25.26 25.199l13.6 272C39.499 309.972 50.041 320 62.83 320h66.34c12.789 0 23.331-10.028 23.97-22.801l13.6-272C167.425 11.49 156.496 0 142.77 0H49.23C35.504 0 24.575 11.49 25.26 25.199z" class="">\
                            <title> Mandatory </title> \
                        </path>\
                       </svg>'
            ]
        ])
    }

    get MOBILE_DEFAULT_FONTS() {
        return Object.freeze({
            "control_section": { id: 1, fontSize: 18, name: "Section", show: true, showAlignment: true },
            "control_text": { id: 2, fontSize: 14, name: "Text", show: true, showAlignment: true },
            "control_small_text": { id: 3, fontSize: 10, name: "Small Text", show: true, showAlignment: true },
            "control_large_heading": { id: 4, fontSize: 20, name: "Large Heading", show: true, showAlignment: true },
            "control_medium_heading": { id: 5, fontSize: 18, name: "Medium Heading", show: true, showAlignment: true },
            "control_small_heading": { id: 6, fontSize: 16, name: "Small Heading", show: true, showAlignment: true },
            "control_text_input": { id: 8, fontSize: 14, name: "Text Input", show: true, showAlignment: true },
            "control_numeric_input": { id: 13, fontSize: 14, name: "Numeric Input", show: true, showAlignment: true },
            "control_advanced_input": { id: 13, fontSize: 14, name: "Advanced Inputs", show: true, showAlignment: false },
            "control_link": { id: 7, fontSize: 14, name: "Link", show: true, showAlignment: false },
            "control_button": { id: 9, fontSize: 14, name: "Buttons", show: true, showAlignment: false },
            "control_checkbox": { id: 10, fontSize: 14, name: "Checkboxes", show: true, showAlignment: false },
            "control_table": { id: 11, fontSize: 16, name: "Table Header", show: true, showAlignment: false },
            "control_margin": { id: 12, marginSize: 8, name: "Margin", show: false, showAlignment: false },
        });
    }

    
    get DEFAULT_WIZARD_STYLES() {
        return {
            marginSpacing: this.MARGIN_DEFAULT_10,
            maxAppWidth: 650,
            fontFamily: 'Poppins',
            fontStyling: Object.fromEntries(
                Object.entries(this.MOBILE_DEFAULT_FONTS).map(([key, value]) =>
                    [key, {
                        fontSize: value.fontSize,
                        name: value.name,
                        show: value.show,
                        fontWeight: 'normal',
                        fontStyle: 'normal',
                        textAlign: key === 'control_numeric_input' ? 'right' : 'left',
                        showAlignment: value.showAlignment,
                    }]
                )
            )
        }
    };

    get MOBILE_DEFAULT_SETTINGS(){
        return Object.freeze({
                1: { name: "currentStep", value: 0 }
            }
        );
    }

    get MOBILE_DEFAULT_WIZARD_COMPLETED(){ return false; }
    get MOBILE_DEFAULT_TIMES_COMPLETED () { return 0 ;}

    get NAME_CURRENT_STEP (){ return "currentStep"}

 
    get MOBILE_DEFAULT_STEP(){ return 1; }
    get MOBILE_FIRST_STEP(){ return 1; } 

    get DROPABLE_SECTION(){ return "droppable-section"}
    get MOBILE_ROW_MARGIN(){ return "mobile-row-margin"}

    get FIRST_COLUMN_NAME(){ return "Column 1";}
    get FIRST_COLUMN_ORDER(){ return 1; } 
    get FIRST_COLUMN_HEADER(){ return "Column 1 Layout"; } 

    get SECOND_COLUMN_NAME(){ return "Column 2";}
    get SECOND_COLUMN_ORDER(){ return 2; }
    get SECOND_COLUMN_HEADER(){ return "Column 2 Layout"; }
    get SECOND_COLUMN_PLACEHOLDER_ID(){ return "columnRightDropArea"; }
    
    get CURRENT_COLUMN_NAME(){ return "Column"}   
    get CURRENT_COLUMN_ORDER(){ return 0}

    get HELP_LINK(){ return "https://www.perfectapps.com/help/index2.php?id="}
    get STEPS_CONSTANTS(){
        return new Map([
            [
                0, {
                    title: "",
                    goalText: "", 
                    navigation_help_id: "", goal_help_id:"", attributes_help_id:""
                   }
            ],
            [
                1, {
                    title: "Step 1: Create and Name Sections",
                    goalText: "Select a page on the Navigation Panel, then create and name sections on the Properties Panel so you can group objects on Step 2. Any page without a section will be hidden.", 
                    navigation_help_id: "mw_nav_1", goal_help_id:"mw_goal_1", attributes_help_id:"mw_properties_1"
                   }
            ],
            [
                2, {
                    title: "Step 2: Layout Setup",
                    goalText: "Select a page on the Navigation Panel, then drag and drop objects from the canvas to the sections on the Properties Panel. Any section without a object will be hidden.", 
                    navigation_help_id: "mw_nav_2", goal_help_id:"mw_goal_2", attributes_help_id:"mw_properties_2"
                   }
            ],
            [
                3, {
                    title: "Step 3: Create an Optional Two Column Layout",
                    goalText: "A two column layout is ideal for a phone in landscape mode or a tablet. A phone in portrait mode will always display the default one column layout defined in Step 2. Setting up a two column layout is optional. To create a two column layout for any page, select a page, then drag and drop sections from Column 1 to Column 2. To view or modify the default one column layout, go back to Step 2.",
                    navigation_help_id: "mw_nav_3", goal_help_id:"mw_goal_3", attributes_help_id:""
                   }
            ],
            [
                4, {
                    title: "Step 4: Preview the Mobile App Layout",
                    goalText: "Use the Navigation panel to view each page and review the visual layout. Click Preview to view the app as the user would, you can select a Device, Orientation, Stage, and Role to preview your app as Mobile and ensure everything required is present. If no adjustments are necessary, click Finish to complete the Mobile Apps Wizard.", 
                    navigation_help_id: "mw_nav_4", goal_help_id:"mw_goal_4", attributes_help_id:""
                   }
            ]
        ])
    }

    /* Tooltips */
    get EYESLASH_TOOLTIP(){return "Hidden"}
    get SECTION_COUNT_TOOLTIP(){return "Section Count"}
    get HELP_TOOLTIP(){return "Help"}
    get NEW_OBJECT_TOOLTIP(){return "Changes Detected"}
    get MAXIMIZE_PANEL_TOOLTIP(){return "Maximize"}
    get MINIMIZE_PANEL_TOOLTIP(){return "Minimize"}
    get RESET_PAGE_TOOLTIP(){return "Reset Page"}
    get MAXIMIZE_TOOLTIP() { return "Maximize" }
    get RESTORE_TOOLTIP() { return "Restore Down" }
    get TWO_COLUMNS_TOOLTIP(){ return "Two column configuration"}
    get REMOVE_TOOLTIP(){ return "Remove"}


    /*Controls*/

    get SECTION_FACTORY_KEY(){ return 'control_section'}
    get BAR_CHART_FACTORY_KEY(){ return 'control_bar_chart'}
    get GAUGE_CHART_FACTORY_KEY(){ return 'control_gauge_chart'}
    get BULLET_TEXT_FACTORY_KEY(){ return 'control_bullet_text'}
    get BUTTON_FACTORY_KEY(){ return 'control_button'}
    get CAPTCHA_FACTORY_KEY(){ return 'control_captcha'}
    get CHECKBOX_FACTORY_KEY(){ return 'control_checkbox'}
    get CHECKBOX_GROUP_FACTORY_KEY(){ return 'control_checkbox_group'}
    get CROSSTAB_FACTORY_KEY(){ return 'control_crosstab'}
    get CLEAR_FILTER_BUTTON_FACTORY_KEY(){ return 'control_clear_filter_button'}
    get FILTER_INPUT_FACTORY_KEY(){ return 'control_filter_input'}
    get DATA_GRID_FACTORY_KEY(){ return 'control_data_grid'}
    get DATA_LIST_FACTORY_KEY(){ return 'control_data_list'}
    get DATE_CALENDAR_FACTORY_KEY(){ return 'control_date_calendar'}
    get DATE_INPUT_FACTORY_KEY(){ return 'control_date_input'}
    get DROP_DOWN_FACTORY_KEY(){ return 'control_drop_down'}
    get FILE_ATTACHMENT_FACTORY_KEY(){ return 'control_file_attachment'}
    get FILTER_SELECTOR_FACTORY_KEY(){ return 'control_filter_selector'}
    get GROUP_FACTORY_KEY(){ return 'control_group'}
    get HORIZONTAL_SEPARATOR_FACTORY_KEY(){ return 'control_horizontal_separator'}
    get HORIZONTAL_SLIDER_FACTORY_KEY(){ return 'control_horizontal_slider'}
    get IMAGE_INPUT_FACTORY_KEY(){ return 'control_image_input'}
    get LARGE_HEADING_FACTORY_KEY(){ return 'control_large_heading'}
    get LINE_CHART_FACTORY_KEY(){ return 'control_line_chart'}
    get LINK_FACTORY_KEY(){ return 'control_link'}
    get LIST_FACTORY_KEY(){ return 'control_list'}
    get MASK_TEXT_INPUT_FACTORY_KEY(){ return 'control_mask_text_input'}
    get MEDIUM_HEADING_FACTORY_KEY(){ return 'control_medium_heading'}
    get MOVIE_FACTORY_KEY(){ return 'control_movie'}
    get MULTIPLE_TEXT_INPUT_FACTORY_KEY(){ return 'control_multiple_text_input'}
    get NUMERIC_INPUT_FACTORY_KEY(){ return 'control_numeric_input'}
    get NUMERIC_STEPPER_FACTORY_KEY(){ return 'control_numeric_stepper'}
    get PAGE_FACTORY_KEY(){ return 'control_page'}
    get PAGE_BUTTON_FACTORY_KEY(){ return 'control_page_button'}
    get PASSWORD_INPUT_FACTORY_KEY(){ return 'control_password_input'}
    get PICTURE_FACTORY_KEY(){ return 'control_picture'}
    get PIE_CHART_FACTORY_KEY(){ return 'control_pie_chart'}
    get PLAY_FORM_BUTTON_FACTORY_KEY(){ return 'control_play_form_button'}
    get PLAY_REPORT_BUTTON_FACTORY_KEY(){ return 'control_play_report_button'}
    get PRINT_BUTTON_FACTORY_KEY(){ return 'control_print_button'}
    get PROGRESS_BAR_FACTORY_KEY(){ return 'control_progress_bar'}
    get RADIO_BUTTON_FACTORY_KEY(){ return 'control_radio_button'}
    get RADIO_BUTTON_GROUP_FACTORY_KEY(){ return 'control_radio_button_group'}
    get RANKING_FACTORY_KEY(){ return 'control_ranking'}
    get SMALL_HEADING_FACTORY_KEY(){ return 'control_small_heading'}
    get SMALL_TEXT_FACTORY_KEY(){ return 'control_small_text'}
    get SOUND_FACTORY_KEY(){ return 'control_sound'}
    get SUBMIT_BUTTON_FACTORY_KEY(){ return 'control_submit_button'}
    get TABLE_FACTORY_KEY(){ return 'control_table'}
    get TEXT_FACTORY_KEY(){ return 'control_text'}
    get TEXT_INPUT_FACTORY_KEY(){ return 'control_text_input'}
    get TEXT_SEARCH_FACTORY_KEY(){ return 'control_text_search'}
    get TIME_INPUT_FACTORY_KEY(){ return 'control_time_input'}
    get TIMER_FACTORY_KEY(){ return 'control_timer'}
    get VALUE_FACTORY_KEY(){ return 'control_value'}
    get VERTICAL_SEPARATOR_FACTORY_KEY(){ return 'control_vertical_separator'}
    get VERTICAL_SLIDER_FACTORY_KEY(){ return 'control_vertical_slider'}
    get WEBSIGNATURE_FACTORY_KEY(){ return 'control_websignature'}
    get SECTION_TEXT_KEY(){ return 'control_sections_text'}
    get MARGIN_KEY(){ return 'control_margin'}

    get COLUMN_ONE_CLASS() {return 'column-1' }
    get COLUMN_TWO_CLASS() {return 'column-2' }

    get ORIENTATION_PORTRAIT_NAME() {return 'Portrait' }
    get DEVIDE_PHONE_NAME() {return 'Phone' }
    get ICON_PULSE() {return '!' }
    get ONE_MINUTE() { return 60000;}

    get OTHER_TEXTS_FACTORY_KEYS() {
        return [
            this.LARGE_HEADING_FACTORY_KEY,
            this.MEDIUM_HEADING_FACTORY_KEY,
            this.SMALL_HEADING_FACTORY_KEY,
            this.SMALL_TEXT_FACTORY_KEY,
            this.LINK_FACTORY_KEY          
        ]
    }

    get TEXTS_FACTORY_KEYS() {
        return [
            this.TEXT_FACTORY_KEY,
            this.BULLET_TEXT_FACTORY_KEY,
            this.SMALL_TEXT_FACTORY_KEY
        ]
    }

    get BUTTONS_FACTORY_KEYS() {
        return [
            this.BUTTON_FACTORY_KEY,
            this.SUBMIT_BUTTON_FACTORY_KEY,
            this.PAGE_BUTTON_FACTORY_KEY,
            this.PRINT_BUTTON_FACTORY_KEY,
            this.PLAY_FORM_BUTTON_FACTORY_KEY,
            this.PLAY_REPORT_BUTTON_FACTORY_KEY,
            this.FILE_ATTACHMENT_FACTORY_KEY
        ]
    }

    get INPUTS_FACTORY_KEYS() {
        return [
            this.TEXT_INPUT_FACTORY_KEY,
            this.DATE_INPUT_FACTORY_KEY,
            this.TIME_INPUT_FACTORY_KEY,
            this.MULTIPLE_TEXT_INPUT_FACTORY_KEY,
            this.PASSWORD_INPUT_FACTORY_KEY,
            this.NUMERIC_STEPPER_FACTORY_KEY,
            this.DROP_DOWN_FACTORY_KEY,
            this.MASK_TEXT_INPUT_FACTORY_KEY,
            this.LIST_FACTORY_KEY,
            this.HORIZONTAL_SLIDER_FACTORY_KEY,
            this.RANKING_FACTORY_KEY
        ]
    }

    get INPUTS_WITH_ALIGNMENT_FACTORY_KEYS() {
        return [
            this.TEXT_INPUT_FACTORY_KEY,
            this.PASSWORD_INPUT_FACTORY_KEY
        ]
    }

    get ADVANCED_INPUTS_FACTORY_KEYS() {
        return [
            this.DATE_INPUT_FACTORY_KEY,
            this.TIME_INPUT_FACTORY_KEY,
            this.MULTIPLE_TEXT_INPUT_FACTORY_KEY,
            this.NUMERIC_STEPPER_FACTORY_KEY,
            this.DROP_DOWN_FACTORY_KEY,
            this.MASK_TEXT_INPUT_FACTORY_KEY,
            this.LIST_FACTORY_KEY,
            this.FILE_ATTACHMENT_FACTORY_KEY //File input needs to be both in buttons and advanced inputs
        ]
    }

    get RIGHT_ALIGNED_INPUTS_FACTORY_KEYS() {
        return [
            this.NUMERIC_INPUT_FACTORY_KEY,
        ]
    }

    get CHECKBOXS_FACTORY_KEYS() {
        return [
            this.CHECKBOX_FACTORY_KEY,
            this.RADIO_BUTTON_FACTORY_KEY

        ]
    }

    get GROUPS_FACTORY_KEYS() {
        return [
            this.CHECKBOX_GROUP_FACTORY_KEY,
            this.RADIO_BUTTON_GROUP_FACTORY_KEY,
            this.GROUP_FACTORY_KEY

        ]
    }

    get COLUMN_ONE_CONTENT_ID() { return '#column1-content'; }

    get UPDATE_HEIGHT_EXCEPTION() {
        return [
            this.WEBSIGNATURE_FACTORY_KEY,
            this.HORIZONTAL_SLIDER_FACTORY_KEY,
            this.RANKING_FACTORY_KEY,
            this.CHECKBOX_GROUP_FACTORY_KEY,
            this.RADIO_BUTTON_GROUP_FACTORY_KEY,
            this.GROUP_FACTORY_KEY
        ]
    }

    get UPDATE_HEIGHT_EXCEPTION() {
        return [
            this.WEBSIGNATURE_FACTORY_KEY,
            this.HORIZONTAL_SLIDER_FACTORY_KEY,
            this.RANKING_FACTORY_KEY,
            this.CHECKBOX_GROUP_FACTORY_KEY,
            this.RADIO_BUTTON_GROUP_FACTORY_KEY,
            this.GROUP_FACTORY_KEY
        ]
    }


    get FORM_LOAD_WAIT_TIME() { return 800;}
    get PUBLISH_FORM_ACTIVATE_MOBILE_MESSAGE_TEXT() { return 'A mobile app is available, would you like to make it active?';}
    get PUBLISH_FORM_MOBILE_INCOMPLETE_MESSAGE_TEXT() { return 'The mobile version is incomplete and will be set to inactive. Your app will continue to function; however mobile users will see the desktop version until the mobile design has been completed.';}
    get PUBLISH_FORM_MOBILE_INCOMPLETE_REFLOW_MESSAGE_TEXT() { return 'Reflow view is turned on for accessibility, yet the mobile design is not complete. Please complete the mobile design before publishing this app version or disable reflow view from the App Properties.';}
    get PUBLISH_FORM_ACTIVATE_MOBILE_REFLOW_MESSAGE_TEXT() { return 'The mobile design is currently inactive, however reflow view is enabled for this app. Please enable the mobile design before publishing this app version or disable Reflow View from the App Properties.';}
    
    get RESET_MOBILE_FORM() { return 'Restart will clear all Mobile Apps Wizard settings and begin a new mobile app. You cannot undo a restart. Are you sure you would like to restart and begin a new mobile app?';}


    get PROP_MAIN_MOBILE_MARGINS() { return '#propMainMobileMargins'; }

    get MOBILE_WARNING_RESET_COLUMNS() {
        return "A section must be present in Column 2 Layout. Removing all sections from Column 2 will restore {Page name} to the default (1 column setting). Are you sure you would like to reset Column 2 for {Page name}?";
    }

    get CREATE_DRAGGABLE_SECTION() {
        return 'createDraggableSections';
    }

    get CREATE_DRAGGABLE_MOBILE_CONTROLS() {
        return 'createDraggableMobileControls';
    }
  
}



const constants = new MobileFormsConstants;
export default constants;